module.exports = "/images/ny-life1-11.jpg";